'use strict';
var ActionTypes = require('../constants/ActionTypes');
var projectLoadHelper = require('../helper/projectLoadHelper');
var _ = require('underscore');
var logHelper = require('../helper/timeLogHelper');
var apiHelper = require('../helper/apiHelper');

function preLoadPage(id, cb) {
  projectLoadHelper.loadPage(id, function (err, page) {
    cb();
    if (err) {
      console.log(err);
      return;
    }
    if (!page) {
      console.warn('Cannot find this page', id);
    }
  });
}

function preLoadPages(IDs) {
  if (IDs.length === 0) {
    return;
  }
  var toLoadPageID = IDs.shift();
  preLoadPage(toLoadPageID, function () {
    setTimeout(function () {
      preLoadPages(IDs);
    }, 50);
  });
}

function findAllPageIDs(pages) {
  var IDs = [];
  _.each(pages, function (page) {
    if (!page.isModule) {
      IDs.push(page.ID);
    }
    if (page._pages) {
      IDs = IDs.concat(findAllPageIDs(page._pages));
    }
  });
  return IDs;
}

function preLoadAppPages(app) {
  var IDs = findAllPageIDs(app.modules._pages);
  preLoadPages(IDs);
}

function loadApp(app) {
  return function (dispatch) {
    dispatch(openPage(projectLoadHelper.getAppFirstPage(), function () {
      preLoadAppPages(app);
    }));
  };
}

function openPage(id, cb) {
  var start = Date.now();
  return function (dispatch) {
    dispatch(openPageRequest(id));
    projectLoadHelper.loadPage(id, function (err, page) {
      if (err) {
        dispatch(openPageFail(err));
        return;
      }
      if (!page) {
        alert('Cannot find this page');
      }
      page.ID = id;
      logHelper.logPageRead(id, page.title, Date.now() - start);
      dispatch(openPageDone(page));
      if (cb) {
        cb(err, page);
      }
    });
  };
}

function openPageRequest(id) {
  return {
    type: ActionTypes.PAGE_LOAD_REQUEST,
    payload: id
  };
}

function openPageDone(page) {
  return {
    type: ActionTypes.PAGE_LOAD_DONE,
    payload: page
  };
}

function openPageFail(err) {
  return {
    type: ActionTypes.PAGE_LOAD_FAIL,
    payload: err
  };
}

function finishOpenPage(targetPage) {
  return {
    type: ActionTypes.FINISH_OPEN_PAGE,
    payload: targetPage
  }
}

function redirectPage(id, animation) {
  return function (dispatch) {
    dispatch(redirectPageRequest(id));
    projectLoadHelper.loadPage(id, function (err, page) {
      if (err) {
        console.log(err);
        dispatch(redirectPageFail(err));
        return;
      }
      if (!page) {
        alert('Cannot find this page');
      }
      page.ID = id;
      dispatch(redirectPageDone(page, animation));
    });
  };
}

function redirectPageRequest(id) {
  return {
    type: ActionTypes.PAGE_REDIRECT_REQUEST,
    payload: id
  };
}

function redirectPageDone(page, animation) {
  return {
    type: ActionTypes.PAGE_REDIRECT_DONE,
    payload: {
      page: page,
      animation: animation
    }
  };
}

function redirectPageFail(err) {
  return {
    type: ActionTypes.PAGE_REDIRECT_FAIL,
    payload: err
  };
}

function addComment(syncID, syncVersion, pageID, pageName, author, content) {
  return function (dispatch) {
    dispatch(addCommentRequest());
    apiHelper.post('/review/addcomment', {
      syncID: syncID,
      syncVersion: syncVersion,
      pageID: pageID,
      pageName: pageName,
      author: author,
      content: content
    }, function (res) {
      if (res.code === 0) {
        dispatch(addCommentDone(res.payload));
        return
      }
      dispatch(addCommentFail(res.message));
    }, function(msg) {
      dispatch(connectNetFail(msg));
    })
  };
}

function addCommentRequest() {
  return {
    type: ActionTypes.ADD_COMMENT_REQUEST,
    payload: {}
  }
}

function addCommentDone(payload) {
  return {
    type: ActionTypes.ADD_COMMENT_DONE,
    payload: payload
  }
}

function addCommentFail(error) {
  return {
    type: ActionTypes.ADD_COMMENT_FAIL,
    payload: error
  }
}

function connectNetFail(error) {
  return {
    type: ActionTypes.CONNECT_NET_FAIL,
    payload: error
  }
}

function loadReviewData(syncID, syncVersion, pageID) {
  return function (dispatch) {
    dispatch(loadReviewDataRequest());
    apiHelper.get('/review/getreviewdata', {
      syncID: syncID,
      syncVersion: syncVersion,
      pageID: pageID
    }, function (res) {
      if (res.code === 0) {
        return dispatch(loadReviewDataDone(res.payload));
      }
      return dispatch(loadReviewdataFail(res.message));
    }, function(msg) {
      return dispatch(connectNetFail(msg));
    });
  }
}

function loadReviewDataRequest() {
  return {
    type: ActionTypes.LOAD_REVIEW_DATA_REQUEST,
    payload: {}
  };
}

function loadReviewDataDone(data) {
  return {
    type: ActionTypes.LOAD_REVIEW_DATA_DONE,
    payload: data
  }
}

function loadReviewdataFail(error) {
  return {
    type: ActionTypes.LOAD_REVIEW_DATA_FAIL,
    payload: error
  }
}

function addReview(syncID, syncVersion, pageID, pageName, author, data) {
  return function (dispatch) {
    dispatch(addReviewRequest());
    apiHelper.post('/review/addreview', {
      syncID: syncID,
      syncVersion: syncVersion,
      pageID: pageID,
      pageName: pageName,
      author: author,
      data: data
    }, function (res) {
      if (res.code === 0) {
        return dispatch(addReviewDone(res.payload));
      }
      return dispatch(addReviewFail(res.message));
    }, function (msg) {
      return dispatch(connectNetFail(msg));
    })
  };
}

function addReviewRequest() {
  return {
    type: ActionTypes.ADD_REVIEW_REQUEST,
    payload: {}
  }
}

function addReviewDone(data) {
  return {
    type: ActionTypes.ADD_REVIEW_DONE,
    payload: data
  }
}

function addReviewFail(error) {
  return {
    type: ActionTypes.ADD_REVIEW_FAIL,
    payload: error
  };
}

function loadComment(syncID, syncVersion, pageID) {
  return function (dispatch) {
    dispatch(loadCommentRequest());
    apiHelper.get('/review/getcomments', {
      syncID: syncID,
      syncVersion: syncVersion,
      pageID: pageID
    }, function (res) {
      if (res.code === 0) {
        dispatch(loadCommentDone(res.payload));
        return;
      }
      return dispatch(loadCommentFail(res.message));
    })
  }
}

function loadCommentRequest() {
  return {
    type: ActionTypes.LOAD_COMMENT_DATA_REQUEST,
    payload: {}
  }
}

function loadCommentDone(payload) {
  return {
    type: ActionTypes.LOAD_COMMENT_DATA_DONE,
    payload: payload
  }
}

function loadCommentFail(error) {
  return {
    type: ActionTypes.LOAD_COMMENT_DATA_FAIL,
    payload: error
  }
}

function updateReview(syncID, syncVersion, pageID, author, id, data) {
  return function (dispatch) {
    dispatch(updateReviewRequest());
    apiHelper.post('/review/updatereview', {
      syncID: syncID,
      syncVersion: syncVersion,
      pageID: pageID,
      author: author,
      reviewID: id,
      data: data
    }, function (res) {
      if (res.code === 0) {
        dispatch(updateReviewDone(res.payload));
        return;
      }
      dispatch(updateReviewFail());
      //return dispatch(addReviewFail('test error'));
    }, function (msg) {
      return dispatch(connectNetFail(msg));
    });
  }
}

function updateReviewRequest() {
  return {
    type: ActionTypes.UPDATE_REVIEW_REQUEST,
    payload: {}
  };
}

function updateReviewDone(payload) {
  return {
    type: ActionTypes.UPDATE_REVIEW_DONE,
    payload: payload
  };
}

function updateReviewFail() {
  return {
    type: ActionTypes.UPDATE_REVIEW_FAIL,
    payload: {}
  };
}

function removeReview(syncID, syncVersion, pageID, author, id) {
  return function (dispatch) {
    dispatch(removeReviewRequest());
    apiHelper.post('/review/remove', {
      syncID: syncID,
      syncVersion: syncVersion,
      pageID: pageID,
      author: author,
      reviewID: id
    }, function (res) {
      if (res.code === 0) {
        return dispatch(removeReviewDone(id));
      }
      dispatch(removeReviewFail());
    }, function (msg) {
      return dispatch(connectNetFail(msg));
    })
  };
}

function removeReviewRequest() {
  return {
    type: ActionTypes.REMOVE_REVIEW_REQUEST,
    payload: {}
  };
}

function removeReviewDone(id) {
  return {
    type: ActionTypes.REMOVE_REVIEW_DONE,
    payload: id
  }
}

function removeReviewFail() {
  return {
    type: ActionTypes.REMOVE_REVIEW_FAIL,
    payload: {}
  };
}

function showError(error) {
  return {
    type: ActionTypes.ERROR,
    payload: error
  }
}

function clearError() {
  return {
    type: ActionTypes.CLEAR_ERROR,
    payload: {}
  }
}

function loadProjectReviews(syncID) {
  return function (dispatch) {
    dispatch(loadProjectReviewsRequest());
    apiHelper.get('/review/allreviews', {
      id: syncID
    }, function (res) {
      if (res.code === 0) {
        dispatch(loadProjectReviewsDone(res.payload));
        return;
      }
      dispatch(loadProjecReviewsFail(res.message));
    })
  };
}

function loadProjectReviewsRequest() {
  return {
    type: ActionTypes.LOAD_PROJECT_REVIEWS_REQUEST,
    payload: {}
  };
}

function loadProjectReviewsDone(payload) {
  return {
    type: ActionTypes.LOAD_PROJECT_REVIEWS_DONE,
    payload: payload
  };
}

function loadProjecReviewsFail(error) {
  return {
    type: ActionTypes.LOAD_PROJECT_REVIEWS_FAIL,
    payload: error
  };
}

module.exports = {
  loadApp: loadApp,
  openPage: openPage,
  finishOpenPage: finishOpenPage,
  redirectPage: redirectPage,
  loadReviewData: loadReviewData,
  addReview: addReview,
  addComment: addComment,
  loadComment: loadComment,
  updateReview: updateReview,
  removeReview: removeReview,
  showError: showError,
  clearError: clearError,
  loadProjectReviews: loadProjectReviews
};


// WEBPACK FOOTER //
// ./src/actions/AppActions.js